import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {CommonDataService} from '../../common/common-data.service';
import {AuthService} from '../../common/auth.service';
import {OtpService} from '../otp.service';

@Component({
  selector: 'otp-send',
  templateUrl: './send.component.html',
  styleUrls: ['send.component.scss'],
})
export class OtpSendComponent implements OnInit {

  otpSendForm: FormGroup;

  constructor(
    protected authService: AuthService,
    public otpService: OtpService,
    protected commonDataService: CommonDataService,
    protected fb: FormBuilder
  ) {
  }

  public ngOnInit(): void {
    this.otpService.selectedRecipient = null;
    this.otpSendForm = this.fb.group({
      contactId: new FormControl(this.commonDataService.user.billingAccountId, Validators.required)
    });
  }

  public sendOtp(): void {
    let selectedContactId = this.otpSendForm.value['contactId'];
    let selectedRecipient = this.otpService.otpRecipients.find((recipient) => {
      return recipient.contactId === selectedContactId;
    });
    this.otpService.sendOtpSms(selectedRecipient);
  }

  public logout(): void {
    this.authService.logOut(true);
  }

}
